import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { isIOS } from 'react-device-detect';
import { makeStyles } from '@mui/styles';
import { updateCursorPosition } from 'state/actions/action-creators';

type Input = React.DetailedHTMLProps<
  React.InputHTMLAttributes<HTMLInputElement>,
  HTMLInputElement
> & {
  showBackground?: boolean;
  fontFamily: string;
  color: '#00aeef' | '#767676' | '#000';
  fontSize: number;
  value?: string;
  marginTop?: string;
  width?: number;
  maxLength?: number;
  printGray?: boolean;
};

const BaseInput: React.FC<Input> = ({
  fontFamily,
  color,
  showBackground,
  className,
  onChange,
  maxLength,
  fontSize,
  marginTop,
  width = 725,
  value,
  printGray,
  ...props
}) => {
  const dispatch = useDispatch();
  const [inputFilled, setInputFilled] = useState(false);
  const editedWorksheet = useSelector(({ worksheetMaker }: any) => worksheetMaker.editedWorksheet);

  const classes = useStyles({
    fontFamily,
    color,
    backgroundColor: inputFilled ? 'transparent' : '#E5F9FF',
    fontSize,
    marginTop,
    width,
    isIOS
  });

  const handleChange = e => {
    setInputFilled(!!e.target.value);
    onChange?.(e);
  };

  const handleOnBlur = e => {
    onChange?.(e);
    dispatch(updateCursorPosition(+editedWorksheet.formKey, e.target.selectionStart));
  };

  const onFocus = e => {
    onChange?.(e);
    dispatch(updateCursorPosition(+editedWorksheet.formKey, e.target.selectionStart));
  };

  useEffect(() => {
    setInputFilled(!!value);
  }, [value]);

  return (
    <input
      id={printGray ? 'print-gray' : 'base-input'}
      maxLength={maxLength ?? 50}
      style={{ color: color, marginTop: marginTop }}
      className={`${classes.baseInputClass} ${className}`}
      onChange={handleChange}
      onBlur={handleOnBlur}
      onFocus={onFocus}
      value={value}
      aria-label={props['aria-label'] ?? props.placeholder}
      {...props}
    />
  );
};

const useStyles = makeStyles(() => ({
  baseInputClass: ({ fontFamily, color, backgroundColor, fontSize, marginTop, width }: any) => ({
    display: 'flex',
    zIndex: 10,
    marginTop: marginTop,
    fontSize: `${fontSize}px`,
    position: 'absolute',
    backgroundColor,
    border: 'none',
    width: width || 900,
    ...(isIOS && { padding: '0 5px !important' }),
    fontFamily,
    paddingLeft: '5px',
    color: color,
    '&:focus': {
      border: 'none'
    },
    '&:active': {
      border: 'none'
    },
    '&:placeholder-shown': {
      opacity: 0.7
    }
  })
}));
export default BaseInput;
